import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import AcaoAuditoria from "model/auditoria5s/auditoria/AcaoAuditoria";
import ClassePlanoAuditoria from "model/auditoria5s/planoDeAuditoria/ClassePlanoAuditoria";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class AcaoAuditoriaService implements BaseServiceCadastros<AcaoAuditoria> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/acaoAuditoria/pesquisar`;
            if (filters) {
                url += getFilters(filters)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisarMinhas(pageable: Pageable, filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/acaoAuditoria/pesquisar/minhas`;
            if (filters) {
                url += getFilters(filters)
            }
            const params = {
                page: pageable.page,
                size: pageable.size,
                sort: pageable.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<AcaoAuditoria>((resolve, reject): void => {
            api
                .get(`/acaoAuditoria/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultarMinha(id: number) {
        return new Promise<AcaoAuditoria>((resolve, reject): void => {
            api
                .get(`/acaoAuditoria/consultar/minha/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }


    incluir(setor: AcaoAuditoria) {
        return new Promise<AcaoAuditoria>((resolve, reject): void => {
            api
                .post(`/acaoAuditoria/incluir`, JSON.stringify(setor))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(setor: AcaoAuditoria) {
        return new Promise<AcaoAuditoria>((resolve, reject): void => {
            api
                .put(`/acaoAuditoria/editar`, JSON.stringify(setor))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/acaoAuditoria/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    salvarAcao(acao: AcaoAuditoria) {

        return new Promise<AcaoAuditoria>((resolve, reject): void => {
            api
                .post(`/auditoria/app/acao`, JSON.stringify(acao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    verificacoes() {
        return new Promise<Array<PlanoAuditoria>>((resolve, reject): void => {
            const url = `/acaoAuditoria/verificacoes`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    classesVerificacao(verificacao: PlanoAuditoria) {
        return new Promise<Array<ClassePlanoAuditoria>>((resolve, reject): void => {
            const url = `/acaoAuditoria/classesVerificacao/${verificacao.id}`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    getStatusFilter() {
        return [
            { label: 'Criada', value: 'C' },
            { label: 'Em andamento', value: 'A' },
            { label: 'Finalizada', value: 'F' }
        ]
    }

    getSetoresDisponiveis() {
        return new Promise<Setor[]>((resolve, reject): void => {
            api
                .get(`/acaoAuditoria/setoresDisponiveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getUsuarios() {
        return new Promise<Array<Usuario>>((resolve, reject): void => {
            api
                .get(`/acaoAuditoria/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getStatus(status: string): string {

        if (status === 'EM_ANDAMENTO') {
            return 'Em andamento';
        } else if (status === 'FINALIZADO') {
            return 'Finalizada';
        }

        return 'Criada';
    }

}

export default AcaoAuditoriaService;
